export const css = {
    root: 'JP88AI2t',
    ' _key': 'apic-theme/dojo/grid-body'
};
export default css;
